import { CustomPromsScatterLegend } from "../CustomPromsScatterLegend/CustomPromsScatterLegend";
import {
  ChartLegendContainer,
  Container,
} from "./CustomPromsScatterGraphLegend.style";

type CustomPromsScatterGraphLegend = {
  showValues: boolean;
  valueColorMap: Record<string, string>;
};

export function CustomPromsScatterGraphLegend({
  showValues,
  valueColorMap,
}: CustomPromsScatterGraphLegend) {
  const chartLegendContainer = (
    <ChartLegendContainer paddingLeft={!showValues}>
      <CustomPromsScatterLegend valueColorMap={valueColorMap} />
    </ChartLegendContainer>
  );

  return (
    <div style={{ position: "relative", paddingLeft: "106px" }}>
      <Container>{chartLegendContainer}</Container>
    </div>
  );
}
